<div class="provider-photo" *ngIf="photoUrl">
  <img src="{{photoUrl}}" alt="{{ providerName }}'s profile photo">
</div>
<div class="initials" *ngIf="!photoUrl">{{ initials }}</div>